import { Component, OnInit } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { PopoverController } from '@ionic/angular';
import { TokenService } from 'src/app/services/token.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit {

  isUpdateAvailable = false;

  constructor(
    public updates: SwUpdate,
    private popoverController: PopoverController,
    private tokenService: TokenService) { }

  ngOnInit() {
    this.updates.available.subscribe(event => {
      this.isUpdateAvailable = true;
    });
  }

  about(){
    this.popoverController.dismiss('about');
  }

  update() {
      this.updates.activateUpdate().then(() => document.location.reload());
    this.popoverController.dismiss('update');
  }

  logout() {
    this.tokenService.deleteAccessToken();
    this.popoverController.dismiss('logout');
  }

  eventFromPopover() {
    this.popoverController.dismiss();
  }
}
